import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  calculatingEta: {
    id: 'calculatingEta',
    defaultMessage: 'Calculating driver location',
    description: 'Message to show as we wait for an updated on an ETA'
  },
  delivered: {
    id: 'delivered',
    defaultMessage: 'Delivered',
    description: 'Message to show as ETA when order is delivered'
  }
});
